<p-avatar shape="circle" size="large">
    <i *ngIf = "icon" class="material-icons-outlined">{{icon}}</i>
    <i *ngIf = "tnIcon" class="till-noon-icon {{tnIcon}}"></i>
</p-avatar>
